const isSafeInternalPath = (path = "") =>
  path.startsWith("/") &&
  !path.startsWith("//") &&
  !path.includes("\\") &&
  !/[\r\n]/.test(path);

export const getSafeReturnPath = (search = "") => {
  const returnTo = new URLSearchParams(search).get("returnTo") || "";

  if (!isSafeInternalPath(returnTo)) return "";

  return returnTo;
};

export const getSignInPath = (returnTo = "") => {
  const safeReturnTo = isSafeInternalPath(returnTo) ? returnTo : "";

  return safeReturnTo
    ? `/signin?returnTo=${encodeURIComponent(safeReturnTo)}`
    : "/signin";
};

export const appendReturnTo = (path, returnTo = "") => {
  const safeReturnTo = isSafeInternalPath(returnTo) ? returnTo : "";

  return safeReturnTo
    ? `${path}?returnTo=${encodeURIComponent(safeReturnTo)}`
    : path;
};
